export default __webpack_public_path__ + "static/media/warning--pedestrians-crossing--g1.3b874634.png";